<template>
  <PageViewContainer>
    <CardContainer>
      <template v-slot:title>
        {{ article.name }}
      </template>
      <template v-slot:subTitle>
        {{ article.shortDesc }}
      </template>
      <template v-slot:content>
        <div v-html="article.content"/>
      </template>
    </CardContainer>
  </PageViewContainer>
</template>

<script>
import Axios from '@/core/Axios';
import CardContainer from '@/components/Partials/CardContainer.vue';
import PageViewContainer from '@/components/Partials/PageViewContainer.vue';

export default {
  name: 'ArticleView',
  components: { PageViewContainer, CardContainer },
  data() {
    return {
      axios: new Axios(),
      article: {
        name: null,
        shortDesc: null,
        content: null,
      },
    };
  },
  mounted() {
    this.getArticle();
  },
  computed: {
    slugged: {
      get() {
        return this.$route.params.slugged;
      },
    },
  },
  watch: {
    slugged() {
      this.getArticle();
    },
  },
  methods: {
    getArticle() {
      this.axios.makeCall('GET', `norbit/article/${this.slugged}`)
        .then((response) => {
          if (response) {
            this.article.name = response.name;
            this.article.shortDesc = response.short_desc;
            this.article.content = response.content;
          }
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });
    },
  },
};
</script>

<style scoped>
</style>
